import { schema } from 'normalizr';

export const timeslotSchema = new schema.Entity('timeslots', {}, { idAttribute: '_id' });
export const timeslotListSchema = [timeslotSchema];
